class Recruit {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const recruitSwiper = new Swiper(".recruit-swiper", {
      loop: true,
      slidesPerView: "1",
      centeredSlides: true,
      grabCursor: true,
      allowTouchMove: true,
      pagination: {
        el: ".recruit-swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });

    // アーカイブページ用のスクロール機能
    if ($(".p-recruit-archive").length > 0) {
      this.initArchiveScroll();
    }
  }

  initArchiveScroll() {
    const $sideNavItems = $(".side-nav__item");
    const $archiveWrappers = $(".archive-main__wrapper");
    let isScrolling = false;
    let isInitializing = true; // 初期化中フラグ
    let userScrollTimeout = null; // ユーザースクロール完了判定用
    let clickedTargetId = null; // クリックされたターゲットIDを保持

    // スクロール完了後にis-activeを付与する関数
    const updateActiveOnScrollEnd = () => {
      if (isScrolling || isInitializing) {
        return;
      }

      // クリックされたターゲットが指定されている場合、そのターゲットが正しく表示されているか確認
      // クリックしたターゲットが表示範囲内に到達するまで、クラスを変更しない
      if (clickedTargetId) {
        const $clickedTarget = $(clickedTargetId);
        if ($clickedTarget.length > 0) {
          const rect = $clickedTarget[0].getBoundingClientRect();
          const headerHeight = $(".l-header").outerHeight() || 0;
          const viewportTop = headerHeight + 50;
          
          // クリックしたターゲットが表示範囲内にある場合は、そのまま維持してリセット
          if (rect.top <= viewportTop + 100 && rect.bottom >= viewportTop) {
            clickedTargetId = null; // 確認完了したのでリセット
            return; // クラスは既に設定されているので更新不要
          }
        }
        // クリックしたターゲットがまだ表示範囲外の場合は、クラスを変更せずに終了
        // （下にスクロールする場合、途中で別のセクションに入ってもクラスを維持する）
        return;
      }

      const $activeSection = $archiveWrappers
        .filter(function () {
          const rect = this.getBoundingClientRect();
          const headerHeight = $(".l-header").outerHeight() || 0;
          const viewportTop = headerHeight + 50;
          return rect.top <= viewportTop + 100 && rect.bottom >= viewportTop;
        })
        .first();

      if ($activeSection.length > 0) {
        const activeId = $activeSection.attr("id");
        $sideNavItems.removeClass("is-active");
        $sideNavItems
          .find(`a[href="#${activeId}"]`)
          .closest(".side-nav__item")
          .addClass("is-active");
      }
    };

    // スクロールイベントを監視して、スクロール完了後にis-activeを付与
    $(window).on("scroll", () => {
      // クリックされたターゲットが設定されている場合は、スクロールイベントによる更新をスキップ
      if (clickedTargetId) {
        return;
      }

      // スクロール中フラグを立てる
      isScrolling = true;

      // 既存のタイマーをクリア
      clearTimeout(userScrollTimeout);

      // スクロールが止まってから一定時間後にis-activeを付与
      userScrollTimeout = setTimeout(() => {
        // 再度clickedTargetIdをチェック（クリック中に変更された可能性があるため）
        if (clickedTargetId) {
          return;
        }
        isScrolling = false;
        updateActiveOnScrollEnd();
      }, 150); // 150msスクロールが止まったら完了とみなす
    });

    // アンカーリンクのクリックイベント（ブラウザ標準のアンカー遷移を使用）
    $sideNavItems.find("a").on("click", function () {
      const targetId = $(this).attr("href");
      const $target = $(targetId);
      const $clickedItem = $(this).closest(".side-nav__item");

      if ($target.length > 0) {
        clearTimeout(userScrollTimeout);
        clickedTargetId = targetId;
        $sideNavItems.removeClass("is-active");
        $clickedItem.addClass("is-active");
        isScrolling = true;
        // 標準のアンカー遷移に任せ、一定時間後にフラグを解除してスクロール監視を再開
        setTimeout(() => {
          clickedTargetId = null;
          isScrolling = false;
          updateActiveOnScrollEnd();
        }, 500);
      }
    });

    // 初期状態で最初のセクションが表示されている場合の処理
    const checkInitialActive = () => {
      // 初期化中フラグを立てる（IntersectionObserverを無効化）
      isInitializing = true;

      // まず最初のナビゲーション項目にis-activeを付与
      const $firstNavItem = $sideNavItems.first();
      if ($firstNavItem.length > 0) {
        $sideNavItems.removeClass("is-active");
        $firstNavItem.addClass("is-active");
      }

      // その後、実際に表示されているセクションを確認して更新
      $archiveWrappers.each(function () {
        const rect = this.getBoundingClientRect();
        const headerHeight = $(".l-header").outerHeight() || 0;
        const viewportTop = headerHeight + 50; // 50pxの余白
        const viewportBottom = window.innerHeight * 0.6;

        if (
          rect.top <= viewportTop + 100 &&
          rect.bottom >= viewportTop &&
          rect.top <= viewportBottom
        ) {
          const targetId = $(this).attr("id");
          $sideNavItems.removeClass("is-active");
          $sideNavItems
            .find(`a[href="#${targetId}"]`)
            .closest(".side-nav__item")
            .addClass("is-active");
          return false;
        }
      });

      // 初期化完了後、少し遅延してからフラグを解除
      setTimeout(() => {
        isInitializing = false;
      }, 500);
    };

    // ページ読み込み時に初期状態をチェック
    // DOMContentLoadedとwindow.loadの両方で実行して確実に初期化
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", checkInitialActive);
    } else {
      checkInitialActive();
    }

    // ウィンドウ読み込み完了後にも確認（レイアウトが確定した後）
    $(window).on("load", () => {
      setTimeout(checkInitialActive, 100);
    });
  }
}